"use client";

import React from "react";
import { Activity, ArrowRight, Timer } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const programs = [{
  id: "01",
  title: "Szállásfoglalás",
  description: "Fedezze fel a világ legszebb hoteleit és apartmanjait. Garantáltan a legjobb árakon, rugalmas lemondási feltételekkel minden úti célhoz.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/luxury_hotel_resort.png",
  duration: "Globális",
  level: "Prémium",
  link: "/AccommodationsPage"
}, {
  id: "02",
  title: "Repülőjegyek",
  description: "Hasonlítsa össze több száz légitársaság ajánlatát egyetlen kattintással. Találja meg a leggyorsabb és legolcsóbb útvonalakat bárhová.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/airplane_wing_sunset.png",
  duration: "Azonnali",
  level: "Gyors",
  link: "/FlightsPage"
}, {
  id: "03",
  title: "Taxi & Transzfer",
  description: "Megbízható reptéri transzferek és városi taxi szolgáltatások. Fix árak, profi sofőrök és kényelmes járművek várják az érkezéskor.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/airport_taxi_service.png",
  duration: "24/7",
  level: "Kényelmes",
  link: "/HomePage"
}];
export default function ProgrammesSurMesure() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}